export const PLANS = [
    {
        id: 1,
        badge: "silverBadge",
        productName: "Essentials Plan",
        price: 14.95,
        features: [
            "Unlimited Extensions",
            "Fully Featured",
            "Unlimited Simultaneous Calls",
            "Addons On Demand",
            "Free Modules Available",
            "Always have latest version",
            "2 VitXi WebRTC Softphone",
            "Auto Provisioning",
            "Ticket Support"
        ]
    },
    {
        id: 2,
        badge: "goldBadge",
        productName: "Professional Plan",
        price: 19.95,
        features: [
            "Unlimited Extensions",
            "Fully Featured",
            "Unlimited Simultaneous Calls",
            "Addons On Demand",
            "Free Modules Available",
            "Always have latest version",
            "Unlimited VitXi WebRTC Softphones",
            "Auto Provisioning",
            "Ticket Support",
        ]
    },
    {
        id: 3,
        badge: "diamondBadge",
        productName: "Premium Plan",
        price: 24.95,
        features: [
            "Unlimited Extensions",
            "Fully Featured",
            "Unlimited Simultaneous Calls",
            "Addons On Demand",
            "Free Modules Available",
            "Always have latest version",
            "Unlimited VitXi WebRTC Softphones",
            "Unlimited Vital PBX Connect (IPhone and Android Client)",
            "CRM Integration",
            "Auto Provisioning",
            "Ticket Support",
        ]
    },
    {
        id: 4,
        badge: "blackBadge",
        productName: "Enterprise Plan",
        price: 29.95,
        features: [
            "Unlimited Extensions",
            "Fully Featured",
            "Unlimited Simultaneous Calls",
            "Addons On Demand",
            "Free Modules Available",
            "Always have latest version",
            "Unlimited WebRTC Clients",
            "Unlimited Vital PBX Connect (IPhone and Android Client)",
            "Microsoft Teams Integration",
            "CRM Integration",
            "Auto Provisioning",
            "Ticket Support",
        ]
    },
]